import * as Yup from "yup";
import { isValidAppointmentDateTime } from "./../../../utils/date";

// New schema for multi-invitee appointments
export const BusinessCreateAppointmentSchema = Yup.object().shape({
  invitees: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string(),
        clientId: Yup.string().nullable(),
        clientEmail: Yup.string().email("Invalid email").required("Email is required"),
        firstName: Yup.string(),
        lastName: Yup.string(),
        phone: Yup.string(),
      })
    )
    .min(1, "At least one client must be selected"),
  appointmentDate: Yup.string()
    .required("Apt. Date is required!")
    .test(
      "is-not-past",
      "Appointment date cannot be in the past!",
      value => {
        if (!value) return true;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const selected = new Date(value + "T00:00:00");
        return selected >= today;
      }
    ),
  appointmentTime: Yup.string()
    .required("Apt. Time is required!")
    .test(
      "is-future-time",
      "Appointment time cannot be in the past!",
      function (value) {
        const { appointmentDate } = this.parent;
        if (!appointmentDate || !value) return true;
        return isValidAppointmentDateTime(appointmentDate, value);
      }
    ),
  notes: Yup.string()
});

export const BusinessUpdateAppointmentSchema = Yup.object().shape({
  clientEmail: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  firstName: Yup.string()
    .min(3, "First name is too Short!")
    .max(50, "First name is too Long!")
    .required("First name is required"),
  lastName: Yup.string()
    .min(3, "Last owner is too Short!")
    .max(50, "Last owner is too Long!")
    .required("Last owner is required"),
  appointmentDate: Yup.string()
    .required("Apt. Date is required!")
    .test(
      "is-not-past",
      "Appointment date cannot be in the past!",
      value => {
        if (!value) return true;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const selected = new Date(value + "T00:00:00");
        return selected >= today;
      }
    ),
  appointmentTime: Yup.string()
    .required("Apt. Time is required!")
    .test(
      "is-future-time",
      "Appointment time cannot be in the past!",
      function (value) {
        const { appointmentDate } = this.parent;
        if (!appointmentDate || !value) return true;
        return isValidAppointmentDateTime(appointmentDate, value);
      }
    ),
  notes: Yup.string()
});
